import {
    ChooseDropdown,
    DropdownSelectTrigger,
    Flex,
    Icon,
    PriorityIcon,
    Separator,
    Text,
    Title
} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import cx from 'classnames';
import React from 'react';
import {texts} from '../../texts';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';
import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {getViewTypeOptions} from '../../utils';
import {isRTL} from '../../../../Localization';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';
import {CommonHelpbook} from '../../../../components/Common/CommonHelpbook';
import {HelpContent} from './HelpContent';

interface Props {
    onClose: () => void;
    componentClasses?: string;
    chooseView: (data: DropdownItemData, isSelected: boolean, name?: string) => void;
    view: DropdownItemData;
    refreshForms: () => void;
    zIndex: number;
    session: string;
    closeRoutesAndRemoveCache: () => void;
}

const HEADER_ADP = 'header_adp';

export const Header = observer(
    ({
        componentClasses,
        onClose,
        chooseView,
        view,
        refreshForms,
        zIndex,
        session,
        closeRoutesAndRemoveCache
    }: Props) => {
        const rtl = isRTL();
        const dir = rtl ? 'rtl' : 'ltr';

        const handleClose = () => {
            onClose();
        };

        return (
            <Flex
                componentClasses={cx(styles.header, componentClasses)}
                {...createDataTestId('adp-header', true)}
                id={HEADER_ADP + session}
            >
                <Flex>
                    <Flex justifyContent="flex-start" style={{gap: '8px'}}>
                        <Title
                            componentClasses={styles.headerTitle}
                            textColor="primary-700"
                            skin="h3"
                            text={texts.ADP_title}
                            {...createDataTestId('adp-header-title', true)}
                        />
                    </Flex>
                    <Flex
                        componentClasses={styles.marginH}
                        justifyContent="flex-end"
                        direction="row"
                    >
                        <Flex justifyContent="space-between">
                            <Flex justifyContent="flex-end" style={{gap: '8px'}}>
                                <Text skin="paragraph-2" textColor="secondary-500">
                                    {texts.choose_view}
                                </Text>
                                <ChooseDropdown
                                    hasSearch={false}
                                    componentClasses={styles.select}
                                    data={getViewTypeOptions()}
                                    width={250}
                                    onChange={chooseView}
                                    noOptionsText={texts.no_options_text}
                                    usePortal
                                    portalSelector={HEADER_ADP + session}
                                    defaultFocusedIndex={0}
                                    maxScrollHeight={320}
                                    value={view.value}
                                    trigger={
                                        <DropdownSelectTrigger direction={dir} value={view.label} />
                                    }
                                />
                            </Flex>
                        </Flex>
                        <Separator
                            componentClasses={styles.seperator}
                            align="horizontal"
                            height={30}
                        />
                        <ModernTooltip
                            tooltip={texts.reload_form}
                            maxWidth={400}
                            arrowOffset={8}
                            position="top-start"
                            tooltipOffset={8}
                        >
                            <Icon
                                onClick={() => {
                                    closeRoutesAndRemoveCache();
                                    refreshForms();
                                }}
                                icon={PriorityIcon.refresh}
                            />
                        </ModernTooltip>

                        <Separator
                            componentClasses={styles.seperator}
                            align="horizontal"
                            height={30}
                        />
                        <CommonHelpbook
                            helpTitle={texts.helpbok_title}
                            helpText={''}
                            helpContent={<HelpContent />}
                            searchString="ADP"
                            tooltipText={texts.help_icon}
                            tooltipStyle={{
                                maxWidth: 400,
                                arrowOffset: 8,
                                position: 'top-start',
                                tooltipOffset: 8
                            }}
                            zIndex={zIndex}
                        />
                        <ModernTooltip
                            tooltip={texts.exit_form}
                            maxWidth={400}
                            arrowOffset={8}
                            position="top-start"
                            tooltipOffset={8}
                        >
                            <Icon
                                icon={PriorityIcon.closeBig}
                                hoverable
                                iconColor="primary-700"
                                onClick={handleClose}
                            />
                        </ModernTooltip>
                    </Flex>
                </Flex>
            </Flex>
        );
    }
);
